import React, { useState, useContext, useRef, useEffect } from "react";
import Loader from "./Loader";
import supabase from "../utils/supabase";
import { SessionContext } from "../SessionContext";
import PostEditor from "./PostEditor";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";

const NewPost = () => {
  const [value, setValue] = useState("Here goes your post content");
  const titleRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [user_id, setUserId] = useState("");
  const [userInfo, setUserInfo] = useState(null);
  const session = useContext(SessionContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!session) {
      navigate("/signin");
    }

    setUserId(session?.user?.id);
    fetchUserInfo();
  }, []);

  const fetchUserInfo = async () => {
    if (session?.user?.id) {
      const { data, error } = await supabase
        .from("users")
        .select("name, role")
        .eq("id", session.user.id)
        .single();

      if (data) {
        setUserInfo(data);
      }
    }
  };

  const handleCreatePost = async () => {
    const title = titleRef?.current.value;
    if (!title) {
      return;
    }
    console.log("posting");
    console.log(value);

    const result = await supabase.from("posts").insert([
      {
        title: title,
        content: value,
        user_id: session.user?.id,
        likes: 0,
        user_info: userInfo,
      },
    ]);

    if (result.error) {
      console.error("Error inserting post:", result.error);
      return;
    } else {
      console.log("No Issues: ", result);
      navigate("/social");
    }
  };

  return (
    <div className="min-h-screen flex flex-col p-6 border border-gray-400 mx-4 mt-10 rounded-xl bg-white shadow-lg">
      <Loader loading={loading} />
      <div className="flex w-full justify-between items-center mb-4">
        <h1 className="text-2xl font-light text-gray-600 text-left">
          Create a New Post
        </h1>
        <button
          className="px-2 py-1 bg-blue-500 text-white font-semibold rounded-lg shadow-md
          hover:bg-blue-600 hover:shadow-lg transition-all duration-200 focus:outline-none
          focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75"
          onClick={handleCreatePost}
        >
          Post
        </button>
      </div>
      <input
        type="text"
        placeholder="Title"
        ref={titleRef}
        className="w-full p-3 bg-transparent text-black border border-b-transparent
        border-gray-300 focus:border-blue-300 rounded-t-lg focus:outline-none placeholder-black
        font-bold text-lg"
        required
        aria-required={true}
      />
      <div className="flex flex-col w-full h-full ">
        <PostEditor value={value} setValue={setValue} />
      </div>

      <ToastContainer />
    </div>
  );
};

export default NewPost;
